const PaymentMethod = {
  CARD: "CD",
  MANUAL_BANK: "MB", // 무통장
};

export { PaymentMethod };
